import { useState, forwardRef, useImperativeHandle } from 'react';
import BootstrapModal from 'react-bootstrap/Modal';

type ModalPropType = {
  body: any;
  header?: any;
  footer?: any;
  closeCallback?: Function | null;
  [x: string]: any;
}

export type ModalRefObject = {
  show: () => void;
  updateHeader: (component: any) => void;
  updateBody: (component: any) => void;
  updateFooter: (component: any) => void;
}

const Modal = forwardRef<ModalRefObject, ModalPropType>(({ body, header, footer, closeCallback, ...rest }, ref) => {
  // const { body, header, footer, closeCallback, ...rest } = props;
  const [visible, setVisible] = useState(false);
  const [modalHeader, setModalHeader] = useState(header);
  const [modalBody, setModalBody] = useState(body);
  const [modalFooter, setModalFooter] = useState(footer);

  const show = (forceShow: boolean | null = null) => {
    if (forceShow === false || !show === false) {
      closeCallback && closeCallback();
    }
    setVisible(forceShow === null ? !visible : forceShow);
  };
  const updateHeader = (component: any) => setModalHeader(component);
  const updateBody = (component: any) => setModalBody(component);
  const updateFooter = (component: any) => setModalFooter(component);

  useImperativeHandle(
    ref,
    () => ({
      show,
      updateHeader,
      updateBody,
      updateFooter,
    }),
  );

  return (
    <BootstrapModal {...rest} show={visible} onHide={show}>
      <BootstrapModal.Header closeButton>
        {modalHeader && <BootstrapModal.Title>{modalHeader}</BootstrapModal.Title>}
      </BootstrapModal.Header>
      {modalBody && <BootstrapModal.Body>{modalBody}</BootstrapModal.Body>}
      {modalFooter && <BootstrapModal.Footer>{modalFooter}</BootstrapModal.Footer>}
    </BootstrapModal>
  );
});

export default Modal;